import { RouterProvider } from '@tanstack/react-router'
import { router } from './router'
import { useAuth } from '@/lib/auth'
import { HomeWidgetsProvider } from '@/shared/providers/home-widgets-provider'
import { homeWidgets } from './module-registry'

export function App() {
  const { isAuthenticated } = useAuth()
  return (
    <HomeWidgetsProvider widgets={homeWidgets()}>
      <RouterProvider router={router} context={{ isAuthenticated }} />
    </HomeWidgetsProvider>
  )
}
